function minWidth(w = 768) {
  return window.matchMedia(`(min-width: ${w}px)`).matches;
}

export default minWidth;

export function minHeight(h = 800) {
  return window.matchMedia(`(min-height: ${h}px)`).matches;
}
